export default "__VITE_ASSET__C4OtKEIc__"